import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core/';

import CountUp from 'react-countup';

import IconNature from '../../../assets/icon-nature.svg';

const Root = styled.div`
	padding: 0 20px;

	h6 {
		margin-top: 20px;
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
	}

	.counter {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		text-align: center;
		transform: translateY(-50%);

		& > span {
			font-size: 48px;
			font-weight: bold;
			color: ${(props) => props.theme.palette.text.primary};
			background-image: ${(props) => props.theme.palette.text.gradient};
			background-clip: text;
			-webkit-background-clip: text;
			-moz-background-clip: text;
			-moz-text-fill-color: transparent;
			-webkit-text-fill-color: transparent;
		}
	}
`;

const FoodPrintcontainer = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	background-color: ${(props) =>
		props.theme.palette.blocks.graph.content.backgroundColorCo2};
	font-size: 14px;
	font-weight: bold;

	img {
		max-width: 45px;
		width: 100%;
		height: auto;
		margin-right: 20px;
	}
`;

const ContentLoadPeakCurrent = ({ counterNumber = 0.76, activeCase, co2reduction }) => (
	<>
		{activeCase ? (
			<>
				<Root>
					<Typography variant="h6">Auswertung des Lastgangs</Typography>
					<Typography>Lastspitze mit Batteriespeicher</Typography>
					<div className="counter">
						<CountUp
							start={0}
							end={counterNumber}
							duration={2.75}
							separator="."
							decimals={2}
							decimal=","
							suffix=" <span>kW</span>"
						/>
					</div>
				</Root>
			</>
		) : (
			<>
				<Root>
					<Typography variant="h6">Auswertung des Lastgangs</Typography>
					<Typography>
						Strombezug mit Photovoltalk (PV-Anlage) und Batteriespeicher:
					</Typography>
					<div className="counter">
						<CountUp
							start={0}
							end={counterNumber}
							duration={2.75}
							separator="."
							decimals={2}
							decimal=","
							suffix=" <span>MWh</span>"
						/>
					</div>
				</Root>

				<FoodPrintcontainer>
					<img src={IconNature} alt="Ihr CO2 Fußabdruck" />
					<span>
						Ihr CO<sub>2</sub> Fußabdruck läge bei{' '}
						<CountUp
							start={0}
							end={co2reduction}
							duration={2.75}
							separator="."
							decimals={2}
							decimal=","
							suffix=" Kg"
						/>
					</span>
				</FoodPrintcontainer>
			</>
		)}
	</>
);

export default ContentLoadPeakCurrent;
